/** we keep this the same as apollo */
export const INTERNAL_ERROR_CODE = 'INTERNAL_SERVER_ERROR';

export type ErrorExtensions = Record<string, unknown>;

// we do not extend from graphql error so we can reuse errors more easily at other parts of the app as well
export abstract class AppError extends Error {
  public readonly extensions: ErrorExtensions;
  /**
   * @param statusCode while graphql doesn't use status codes for errors, we want to know what status code an error represent to increase our logging capabilities
   */
  protected constructor(
    message: string,
    public readonly code: string,
    public readonly statusCode: number,
    extensions?: ErrorExtensions
  ) {
    super(message);

    // we follow the extension pattern just like in graphql to make the default error handling in our app better
    this.extensions = {
      ...(extensions ?? {}),
      code,
    };
  }
}
export class ForbiddenError extends AppError {
  public constructor(message = 'Forbidden', extensions?: ErrorExtensions) {
    super(message, 'FORBIDDEN', 403, extensions);

    Object.defineProperty(this, 'name', { value: 'ForbiddenError' });
  }
}

export class NotFoundError extends AppError {
  public constructor(message = 'Not-found', extensions?: ErrorExtensions) {
    super(message, 'NOT-FOUND', 404, extensions);

    Object.defineProperty(this, 'name', { value: 'NotFoundError' });
  }
}

export class InvalidParamsError extends AppError {
  public constructor(message = 'Invalid params received', extensions?: ErrorExtensions) {
    super(message, 'INVALID_PARAMS', 400, extensions);

    Object.defineProperty(this, 'name', { value: 'InvalidParamsError' });
  }
}

export class TooManyRequestsError extends AppError {
  public constructor(message = 'Too many requests', extensions?: ErrorExtensions) {
    super(message, 'TOO_MANY_REQUESTS', 429, extensions);

    Object.defineProperty(this, 'name', { value: 'TooManyRequestsError' });
  }
}
